import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {MenuIconButtonWithDropdown} from '../components/menu-icon-button-with-dropdown'
import {myCompanyPage} from '../constants'
import {goto, gotoProject} from '../handlers/main-handlers'
import {useMainMenuStore} from '../main-menu-store'

export const ProjectsMenuItem = observer(() => {
  const [state] = useMainMenuStore()
  const {projects, currentProject} = state

  const options: OptionsItem[] = projects.map(project => {
    const {projectId: id, projectName: text} = project
    return {
      key: id,
      text,
      selected: currentProject?.id === id,
      cb: () => {
        gotoProject(id)
        void Tracking.send(TrackingEvent.leftPanelProjectClick)
      }
    }
  })

  const gotoProjects = () => {
    goto(myCompanyPage)
    void Tracking.send(TrackingEvent.leftPanelMyCompanyClick)
  }

  options.unshift({
    key: 'caption',
    text: Lang.msg.menu.projectsCaption,
    selected: state.currentPage === myCompanyPage,
    cb: () => {
      gotoProjects()
      void Tracking.send(TrackingEvent.leftPanelMyCompanyClick)
    },
    marginBottom: 'mb-1'
  })

  const isMyCompanyPage =
    state.currentPage === myCompanyPage ||
    projects.some(p => currentProject?.id === p.projectId)

  return (
    <MenuIconButtonWithDropdown
      options={options}
      icon="IconBriefcase"
      onClick={gotoProjects}
      active={isMyCompanyPage}
      className="mb-8"
    />
  )
})
